<ng-container *ngIf="loading" >
    <div class="loading-bar">
      <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
  </div>
</ng-container>

<div class="container">
    <ng-container *ngIf="displayData">
      <ng-container *ngIf = "SelectedSession !== ''">
        <ng-container *ngIf="selectedSessionTime as session">
          <tm1-badge class="attendanceBadge" appearance="accent" baseColor="new" circular="True">
          <ng-container *ngIf="session?.startEpoch">{{ (+session.startEpoch * 1000) | date:'shortTime' }} to {{ (+session.endEpoch * 1000) | date:'shortTime' }}</ng-container>
          </tm1-badge>
        </ng-container>
      </ng-container>

      <app-modern-summary
        [attendanceSummary]="attendanceSummary"
        [date]="date"
        [venueTimezone]="venueTimezone"
        [useDarkMode]="useDarkMode"
        [stopDataToggle]="stopDataToggle"
        [liveButton]="liveButton"
        [liveDate]="LiveDate"
        [showShare]="false"
        [showEmail]="false"
        [showSchedule]="false"
        [showErrorBreakdown]="false"
        (download)="downloadSummaryCSV()"
        (pause)="stopData()"
        (play)="liveData()"
        (darkModeToggle)="setDarkMode($event)">
      </app-modern-summary>
      <ng-container *ngIf="entranceGroupTable !== undefined">
        <div class="card-container">
          <ng-container *ngFor="let key of venue.objectKeys(attendanceSummary.groupedEntries)">
            <tm1-card class="card">
              <tm1-typography class="card-heading" type="subheading-m">Group Name</tm1-typography>
              <tm1-typography class="card-result" type="subheading-m">{{ key }}</tm1-typography>
              <tm1-typography class="card-heading" type="subheading-m">Entries</tm1-typography>
              <tm1-typography class="card-result" type="subheading-m">{{
                attendanceSummary.groupedEntries[key].entries}}</tm1-typography>
              <tm1-typography class="card-heading" type="subheading-m">Exits</tm1-typography>
              <tm1-typography class="card-result" type="subheading-m">{{
                attendanceSummary.groupedEntries[key].exits}}</tm1-typography>
              <tm1-typography class="card-heading" type="subheading-m">Internal</tm1-typography>
              <tm1-typography class="card-result" type="subheading-m">{{
                attendanceSummary.groupedEntries[key].internal}}</tm1-typography>
              <tm1-typography class="card-heading" type="subheading-m">Reentries</tm1-typography>
              <tm1-typography class="card-result" type="subheading-m">{{
                attendanceSummary.groupedEntries[key].reentries}}</tm1-typography>
              <tm1-typography class="card-heading" type="subheading-m">Inside</tm1-typography>
              <tm1-typography class="card-result" type="subheading-m">{{ attendanceSummary.groupedEntries[key].entries - attendanceSummary.groupedEntries[key].exits + attendanceSummary.groupedEntries[key].reentries  }}</tm1-typography>
            </tm1-card>
          </ng-container>
        </div>
      </ng-container>
      <div class="extended-summary-section" [class.dark]="useDarkMode">
        <div class="extended-summary-heading">
          <span>Extended Summary Options</span>
        </div>
        <div class="extended-summary-buttons">
          <button class="extended-summary-button" type="button"
            [class.active]="showSummary" (click)="toggleTable('showSummary')">Venue Totals</button>
          <button class="extended-summary-button" type="button"
            *ngIf="entranceGroupTable !== undefined"
            [class.active]="showGroup" (click)="toggleTable('showGroup')">Grouped Entrances</button>
          <button class="extended-summary-button" type="button"
            [class.active]="showEntrance" (click)="toggleTable('showEntrance')">Entrances</button>
          <button class="extended-summary-button" type="button"
            [class.active]="showEvent" (click)="toggleTable('showEvent')">Events</button>
          <button class="extended-summary-button" type="button"
            [class.active]="showTicket" (click)="toggleTable('showTicket')">Ticket Types</button>
        </div>
      </div>
      <ng-container *ngIf="showEntrance">
        <div class="extended-summary-table-wrapper" [class.dark]="useDarkMode">
          <table class="extended-summary-table">
            <thead>
              <tr>
                <th class="sortable" (click)="toggleSort('entrances', 'name')">Gate Name <span class="sort-indicator">{{ sortIndicator('entrances', 'name') }}</span></th>
                <th class="sortable" (click)="toggleSort('entrances', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('entrances', 'entries') }}</span></th>
                <th class="sortable" (click)="toggleSort('entrances', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('entrances', 'exits') }}</span></th>
                <th class="sortable" (click)="toggleSort('entrances', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('entrances', 'internal') }}</span></th>
                <th class="sortable" (click)="toggleSort('entrances', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('entrances', 'reentries') }}</span></th>
                <th class="sortable" (click)="toggleSort('entrances', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('entrances', 'inVenue') }}</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let key of sortedEntranceKeysCache">
                <td class="primary-cell">{{ key }}</td>
                <td>{{ attendanceSummary.entrances[key].entries }}</td>
                <td>{{ attendanceSummary.entrances[key].exits }}</td>
                <td>{{ attendanceSummary.entrances[key].internal }}</td>
                <td>{{ attendanceSummary.entrances[key].reentries }}</td>
                <td>{{ attendanceSummary.entrances[key].inVenue }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-container *ngIf="showEvent">
        <div class="extended-summary-table-wrapper" [class.dark]="useDarkMode">
          <table class="extended-summary-table">
            <thead>
              <tr>
                <th class="sortable" (click)="toggleSort('events', 'name')">Event Code <span class="sort-indicator">{{ sortIndicator('events', 'name') }}</span></th>
                <th class="sortable" (click)="toggleSort('events', 'name')">Event Name <span class="sort-indicator">{{ sortIndicator('events', 'name') }}</span></th>
                <th class="sortable" (click)="toggleSort('events', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('events', 'entries') }}</span></th>
                <th class="sortable" (click)="toggleSort('events', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('events', 'exits') }}</span></th>
                <th class="sortable" (click)="toggleSort('events', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('events', 'internal') }}</span></th>
                <th class="sortable" (click)="toggleSort('events', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('events', 'reentries') }}</span></th>
                <th class="sortable" (click)="toggleSort('events', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('events', 'inVenue') }}</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let key of sortedEventKeysCache">
                <td class="primary-cell">{{ key }}</td>
                <td class="primary-cell">
                  <a [href]="attendanceSummary.events[key].url">{{ attendanceSummary.events[key].name }}</a>
                </td>
                <td>{{ attendanceSummary.events[key].entries }}</td>
                <td>{{ attendanceSummary.events[key].exits }}</td>
                <td>{{ attendanceSummary.events[key].internal }}</td>
                <td>{{ attendanceSummary.events[key].reentries }}</td>
                <td>{{ attendanceSummary.events[key].inVenue }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-container *ngIf="entranceGroupTable !== undefined">
        <ng-container *ngIf="showGroup">
          <div class="extended-summary-table-wrapper" [class.dark]="useDarkMode">
            <table class="extended-summary-table" id="groupTable">
              <thead>
                <tr>
                  <th class="sortable" (click)="toggleSort('groupedEntries', 'name')">Grouped Entrance Name <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'name') }}</span></th>
                  <th class="sortable" (click)="toggleSort('groupedEntries', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'entries') }}</span></th>
                  <th class="sortable" (click)="toggleSort('groupedEntries', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'exits') }}</span></th>
                  <th class="sortable" (click)="toggleSort('groupedEntries', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'internal') }}</span></th>
                  <th class="sortable" (click)="toggleSort('groupedEntries', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'reentries') }}</span></th>
                  <th class="sortable" (click)="toggleSort('groupedEntries', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('groupedEntries', 'inVenue') }}</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let key of sortedGroupedKeysCache">
                  <td class="primary-cell">{{ key }}</td>
                  <td>{{ attendanceSummary.groupedEntries[key].entries }}</td>
                  <td>{{ attendanceSummary.groupedEntries[key].exits }}</td>
                  <td>{{ attendanceSummary.groupedEntries[key].internal }}</td>
                  <td>{{ attendanceSummary.groupedEntries[key].reentries }}</td>
                  <td>{{ groupedInside[key] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="showSummary">
        <div class="extended-summary-table-wrapper" [class.dark]="useDarkMode">
          <table class="extended-summary-table" id="summaryTable">
            <thead>
              <tr>
                <th>Entries</th>
                <th>Exits</th>
                <th>Internal</th>
                <th>Reentries</th>
                <th>Inside</th>
              </tr>
            </thead>
            <tbody>
              <tr class="totals-row">
                <td class="primary-cell">{{ attendanceSummary.entries }}</td>
                <td>{{ attendanceSummary.exits }}</td>
                <td>{{ attendanceSummary.internal }}</td>
                <td>{{ attendanceSummary.reentries }}</td>
                <td>{{ attendanceSummary.inVenue }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-container *ngIf="showTicket">
        <div class="extended-summary-table-wrapper" [class.dark]="useDarkMode">
          <table class="extended-summary-table">
            <thead>
              <tr>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'database')">Database <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'database') }}</span></th>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'event')">Event <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'event') }}</span></th>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'name')">Event Name <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'name') }}</span></th>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'ticketType')">Ticket Type <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'ticketType') }}</span></th>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'entries')">Entries <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'entries') }}</span></th>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'exits')">Exits <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'exits') }}</span></th>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'internal')">Internal <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'internal') }}</span></th>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'reentries') }}</span></th>
                <th class="sortable" (click)="toggleSort('ticketTypes', 'inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('ticketTypes', 'inVenue') }}</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of sortedTicketTypesCache">
                <td class="primary-cell">{{ item.database }}</td>
                <td class="primary-cell">{{ item.event }}</td>
                <td class="primary-cell"><a [href]="item.url">{{ item.name }}</a></td>
                <td class="primary-cell">{{ item.ticketType }}</td>
                <td>{{ item.entries }}</td>
                <td>{{ item.exits }}</td>
                <td>{{ item.internal }}</td>
                <td>{{ item.reentries }}</td>
                <td>{{ item.inVenue }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-container *ngIf="showGraph">
        <div *ngIf="timedGateEntries.length" class="chart-container">
          <canvas baseChart
            [datasets]="chartData.datasets"
            [labels]="chartData.labels"
            [options]="chartOptions"
            type="line">
          </canvas>
        </div>
        <div>
        </div>
        <tm1-button (click)="deselectAll()">Unselect All</tm1-button>
        <div class="checkbox-container">
          <div class="checkbox-item" *ngFor="let gate of timedGateEntries">
            <input type="checkbox"
                   [value]="gate.gate"
                   (change)="toggleGateSelection(gate.gate)"
                   [checked]="selectedGates.includes(gate.gate)">
            <label>{{ gate.gate }}</label>
          </div>
          </div>
      </ng-container>
    </ng-container>
  
  <br />
  <br />
  </div>


